import { render } from "./TreeMenuSections.vue?vue&type=template&id=05a61ff3"
import script from "./TreeMenuSections.vue?vue&type=script&lang=js"
export * from "./TreeMenuSections.vue?vue&type=script&lang=js"
script.render = render

export default script